export default __webpack_public_path__ + "static/media/STS1.6 ratio.7ca36724.png";